import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../config/axios.config'
import { GET_PROPERTY_ID } from '../../Constants'

export const getPropertyIdFromProperty = createAsyncThunk('getPropertyId/:id', async (propertyNo: string): Promise<any> => {
  const responseData = await api.get(`/${GET_PROPERTY_ID}/${propertyNo}`)
  return responseData.data
})
